// Fatia S1: criar nova senha a partir do link do e-mail.
import { useState, type FormEvent } from 'react'
import { Link, useParams } from 'react-router-dom'
import { api, ApiError, errorMessage } from '../../lib/api'
import AuthShell, { FormError, FormOk } from '../../features/auth/AuthShell'
import PasswordInput from '../../features/auth/PasswordInput'
import { isDeadLink } from '../../features/auth/link-errors'

export default function ResetPassword() {
  const { token = '' } = useParams()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [done, setDone] = useState(false)
  const [dead, setDead] = useState(false) // link expirado, usado ou malformado: pedir outro
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    if (password.length < 8) return setError('A senha precisa ter pelo menos 8 caracteres.')
    if (password !== confirm) return setError('As senhas não são iguais.')
    setBusy(true)
    try {
      await api.post('/auth/reset-password', { token, password })
      setDone(true)
    } catch (err) {
      if (isDeadLink(err) || (err instanceof ApiError && /expirou|usado/.test(err.message))) setDead(true)
      else setError(errorMessage(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthShell title={dead ? 'Este link não vale mais' : 'Crie uma nova senha'} sub={dead ? undefined : 'Por segurança, os outros aparelhos conectados vão precisar entrar de novo.'}>
      {dead ? (
        <div className="stack" style={{ gap: 14 }}>
          <p className="muted">Ele pode ter expirado ou já ter sido usado. Peça um novo link para criar a senha.</p>
          <Link className="btn primary lg block" to="/recuperar-senha">Pedir um novo link</Link>
          <Link className="btn block" to="/login">Voltar para o login</Link>
        </div>
      ) : done ? (
        <div className="stack" style={{ gap: 14 }}>
          <FormOk>Senha alterada. Agora é só entrar com a nova senha.</FormOk>
          <Link className="btn primary lg block" to="/login">Entrar</Link>
        </div>
      ) : (
        <form className="stack" style={{ gap: 14 }} onSubmit={submit}>
          <FormError error={error} />
          <div className="field">
            <label htmlFor="password">Nova senha</label>
            <PasswordInput id="password" value={password} onChange={setPassword} autoComplete="new-password" describedBy="password-hint" minLength={8} required />
            <p id="password-hint" className="small muted auth-hint">Pelo menos 8 caracteres.</p>
          </div>
          <div className="field">
            <label htmlFor="confirm">Repita a nova senha</label>
            <PasswordInput id="confirm" value={confirm} onChange={setConfirm} autoComplete="new-password" required />
          </div>
          <button type="submit" className="btn primary lg block" disabled={busy}>{busy ? 'Salvando…' : 'Salvar nova senha'}</button>
        </form>
      )}
    </AuthShell>
  )
}
